import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { select, Store } from "@ngrx/store";
import DOMPurify from "dompurify";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StsSelectors } from "src/app/@store/selectors/sts.selectors";

export interface AgreementPreviewData {
  html$: Observable<string>;
  title: string;
}
@Component({
    selector: "app-agreement-preview",
    templateUrl: "./agreement-preview.component.html",
    styleUrls: ["./agreement-preview.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AgreementPreviewComponent {
  sanitizedAgreementHtml$ = this.data.html$.pipe(
    map((html) => {
      const purified = DOMPurify.sanitize(html, {
        ADD_TAGS: ["link"],
        ADD_ATTR: ["href", "rel"],
        FORCE_BODY: true,
      });
      return this.sanitizer.bypassSecurityTrustHtml(purified);
    })
  );
  agreementTitle = this.data.title;

  public isUkDfpInstance$ = this.store.pipe(select(StsSelectors.isUkDfpInstance));
  public isUkShfyInstance$ = this.store.pipe(select(StsSelectors.isUkShfyInstance));

  constructor(
    private readonly store: Store,
    private readonly sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) private readonly data: AgreementPreviewData
  ) {}
}
